// Path URL ERROR
export const URL_406 = '/unauthorized'

// Path URL PUBLIC
export const URL_FORGET_PASSWORD_STEP_1 = '/resetpassword'
export const URL_FORGET_PASSWORD_STEP_2 = '/resetpassword/email'
export const URL_FORGET_PASSWORD_STEP_4 = '/resetpassword/success'

export const URL_LOGIN = '/login'

// Path URL Private
export const HOME = '/'
// export const URL_HOMEPAGE = '/homepage'
export const URL_HOMEPAGE = '/'
export const URL_WAREHOUSE = '/gudang'
export const URL_FORM_WAREHOUSE = '/tambah-gudang'
export const URL_DETAIL_WAREHOUSE = '/gudang/:id'

export const URL_DETAIL_TRANSACTION = '/detail-transaction'
export const URL_DETAIL_TRANSACTION_ID = '/detail-transaction/:id'
export const URL_TRANSACTION_QR_PRINT = '/transaction-qr-print/:id'

// Path URL APPROVAL
export const URL_APPROVAL_BUY = 'approval-saya'
export const URL_APPROVAL_SELL = 'sell'
export const URL_APPROVAL_WITHDRAWAL = 'withdrawal'

// Path Url Farmers
export const URL_FARMERS = '/farmers'
export const URL_FARMERS_REGIST = '/farmers/registrasi'
export const URL_FARMERS_DETAIL = '/farmers/:id'
export const URL_SPATIAL = '/spatial'
export const URL_MANAGE_STOCK = '/manage-stock'
export const URL_CHECK_FARMERS = '/farmers/check'
export const URL_FARMERS_PENDING = '/farmers/pending'
export const URL_FARMERS_GROUPS = '/farmers/groups'
export const URL_FARMERS_SUBGROUP = '/farmers/groups/:id'
export const URL_FARMERS_SHARED = '/farmers/shared'
export const URL_LEARNIING_REPORT = '/learning-report'
export const URL_AGENT_APPROVAL = '/agent-approval'

// pathname repo-komoditas
export const REPO_KOMODITAS = '/repo-komoditas'
export const REPO_KOMODITAS_LIST = '/repo-komoditas/list'

//arus kas
export const ARUS_KAS = '/catatan-arus-kas'
export const HISTORY_ARUS_KAS = '/history-arus-kas'
export const ARUS_KAS_FORM = '/catatan-arus-kas-form'
export const DETAIL_CASHFLOW = '/detail-cashflow'

//Path Url Catatan
export const URL_ARUS_KAS = '/catatan-arus-kas'
export const URL_UTANG = '/utang'
export const URL_UTANG_APPROVAL = '/utang-approval'
export const URL_FORM_UTANG_PIUTANG = '/utang-piutang/form'
export const URL_PIUTANG = '/utang/piutang'
export const URL_PAYMENT_HISTORY = '/utang/payment-history'
export const URL_DETAIL_PIUTANG = '/detail-piutang'
export const URL_DETAIL_UTANG = '/detail-utang'

//url connect account
export const URL_CONNECT_ACCOUNT = '/sambungkan-akun'

//url tnc private
export const URL_TNC_PRIVATE = '/snk'

//url peran dan hak akses
export const URL_ACCESS_ROLE = '/peran-dan-hak-akses'

//URL Master Vessel
export const URL_VESSELS = '/vessels'
export const URL_VESSELS_ADD = '/vessels/add'
export const URL_VESSELS_DETAIL = '/vessels/:id'

// URL USER CATCHES
export const URL_CATCHES = '/catches'
export const URL_CATCHES_DETAIL = '/catches/:id'

// URL GEARS
export const URL_GEARS = '/gears'
export const URL_GEARS_DETAIL = '/gears/:id'

// URL PORTS
export const URL_PORTS = '/ports'
export const URL_PORTS_DETAIL = '/ports/:id'

// URL COMPANIES
export const URL_COMPANIES = '/companies'
export const URL_COMPANIES_ADD = '/companies/add'

// URL FISHERIES
export const URL_FISHERIES = '/fisheries'
export const URL_FISHERIES_ADD = '/fisheries/add'
export const URL_FISHERIES_DETAIL = '/fisheries/:id'

// URL WHISTLE BLOWING
export const URL_WHISTLE_BLOWINGS = '/whistle-blowings'

// URL Kursus
export const URL_KURSUS = '/kursus'
export const URL_KURSUS_DETAIL = '/kursus-detail'
export const URL_FINISH_KURSUS = '/kursus-finished'

// URL AP2HI
export const URL_AP2HI_LOG = '/ap2hi-log'
export const URL_AP2HI_INSIGHT = '/ap2hi-insight'

//inventory
export const URL_INVENTORY = '/inventory'
export const URL_DETAIL_INVENTORY = '/inventory/:id'
export const URL_TRANSFER_INVENTORY = '/transfer-inventory'
export const URL_MUTATION_REPORT = '/mutation-report'
export const URL_MUTATION_REPORT_ID = '/mutation-report/:id'
export const URL_FULFILMENT_REPORT = '/fulfilment-report'
export const URL_FULFILMENT_REPORT_ID = '/fulfilment-report/:id'
export const URL_PROCESSING_REPORT = '/processing-report'

export const URL_FORM_TRANSFER_INVENTORY = '/form-transfer-inventory'
export const URL_TRANSFER_INVENTORY_DETAIL = '/transfer-inventory/:id'

// INVENTORY ANGGOTA
export const URL_INVENTORY_MEMBERS = '/inventory-members'
export const URL_DETAIL_INVENTORY_MEMBER = '/inventory-members/:id'

//Balance
export const URL_BALANCE = '/uang-belanja'

// DAFTAR KONTAK
export const URL_ADDRESS_BOOK = '/address-book'

// LOGIN PASSWORD
export const URL_LOGIN_PASSWORD = '/login-password'

//Pin
export const URL_CONFIRM_PIN_TALANGIN = '/konfirmasi-pin-talangin'
export const URL_CONFIRM_PIN_TRANSAKSI = '/konfirmasi-pin-transaksi'

// ORDER ADJUSTMENT
export const URL_ORDER_ADJUSTMENT = '/order-adjustment'

// CONFIGUTATION AND PNBP
export const URL_CONFIGURATIONS = '/configurations'
export const URL_CONFIGURATIONS_ADD = '/configurations/add'
export const URL_REPORT_PNBP = '/report-pnbp'
export const URL_REPORT_PNBP_DETAIL = '/report-pnbp-detail'

//HARVEST
export const URL_HARVEST = '/harvest'

// WORKPLACE
export const URL_WORKPLACE = '/workplace'

//attendance report
export const URL_ATTENDANCE_REPORT = '/ringkasan-absensi'
export const URL_ATTENDANCE_TODAY = '/absensi-hariini'
export const URL_ATTENDANCE_INDIVIDUAL = '/absensi-individual'
export const URL_ATTENDANCE_REPORT_MEMBER = '/laporan-absensi-anggota'

// ATTENDANCE
export const URL_ATTENDANCE = '/attendance'
export const URL_CENTER_ATTENDANCE = '/center/attendance'

// NOTIF + INBOX
export const URL_NOTIF_INBOX = '/notif-inbox'

//transactions
export const URL_LIST_TRANSACTIONS = '/daftar-transaksi'
export const URL_TRANSACTION_SUMMARY = '/ringkasan-transaksi'

// DETAIL TALANGIN
export const URL_DETAIL_TAGIHAN_TALANGIN = '/detail-tagihan-talangin'

// FINDORA SYNC DATA
export const URL_FINDORA_SYNC_DATA = '/sync-data'
export const URL_FINDORA_PRODUCT_MAPPING = '/product-mapping'
export const URL_FINDORA_PRODUCT_MAPPING_SCHEMA = '/product-mapping-schema'

// FINDORA LOGS
export const URL_FINDORA_LOGS = '/findora-logs'

// PRODUCTION UNIT
export const URL_PRODUCTION_UNIT = '/unit-produksi'
export const URL_FORM_PRODUCTION_UNIT = '/unit-produksi-form'
export const URL_DETAIL_PRODUCTION_UNIT = '/unit-produksi-detail'

// DASHBOARD
export const URL_FINDORA_DASHBOARD = '/esg-dashboard'
export const URL_ANNUAL_CAPACITY = '/annual-capacity'
export const URL_INVENTORI_INTELLIGENCE = '/inventori-intelligence'
export const URL_DETAIL_INVENTORI_INTELLIGENCE = '/inventori-intelligence/:id'
export const URL_PROJECT_SUMMARY_DASHBOARD = '/project-dashboard'

// GRIEVANCE
export const URL_GRIEVANCE = '/pengaduan'

// EVENT PARTNER
export const URL_EVENT_PARTNER = '/event-partner'
export const URL_EVENT_PARTNER_FORM = '/event-partner-form'

// EVENT
export const URL_EVENT = '/event'
export const URL_EVENT_FORM = '/event-form'
export const URL_EVENT_APPROVAL = '/event-appproval'
export const URL_EVENT_TIMELINE = '/event-timeline'
export const URL_EVENT_CERTIFICATE = '/event-certificate'
export const URL_EVENT_CERTIFICATE_DETAIL = '/event-certificate/:id'

// EVENT PARTICIPANT
export const URL_EVENT_PARTICIPANT = '/event-participant'
export const URL_EVENT_PARTICIPANT_FORM = '/event-participant-form'

// PROJECT
export const URL_PROJECTS_MENU = '/projects'
export const URL_PROJECTS_ADD = '/projects/add'
export const URL_PROJECTS_EDIT = '/projects/edit/:id'
export const URL_PROJECT_DETAIL = '/projects/:id'

// MASTER ITEMS & MAP SCHEMA
export const URL_MASTER_ITEMS = '/master-items'
export const URL_MAP_SCHEMA = '/map-schema'
export const URL_FINDORA_ITEMS = '/findora-items'

//PROCESS
export const URL_SESSION_PROCESS = '/process'
export const URL_PROCESS = '/process/list'
export const URL_FORM_PROCESS = '/process/form'
export const URL_SESSION_JOIN = '/process/session-join'
export const URL_SESSION_LIST = '/process/session-list'
export const URL_DETAIL_PROCESS = '/processing-report-detail'

// EMPLOYEE PAYMENTS
export const URL_EMPLOYEE_PAYMENTS = '/employee-payments'
export const URL_WAGE_SALARY = '/wage-salary'
export const URL_WAGE_SALARY_CREATE = '/wage-salary/create'
export const URL_WAGE_SALARY_DETAIL = '/wage-salary/:id'
export const URL_EMPLOYEE_PAYMENTS_SUMMARY = '/employee-payments-summary'
export const URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION =
  '/employee-payments-auto-calculation'

// Preview Document
export const URL_PREVIEW_DOCUMENT = '/preview-document'

//URL SETTINGS
export const URL_SETTINGS = '/pengaturan-profile'
export const URL_SCANNER_SETTING = '/pengaturan-scanner'
export const URL_PRINTER_SETTING = '/pengaturan-printer'
export const URL_AUTONUMBER_SETTING = '/pengaturan-nomor-transaksi'
export const URL_PRICE_TABLE = '/pengaturan-tabel-harga'

//DASHBOARD TRACEABILITY
export const URL_DASHBOARD_TRACEABILITY = '/dashboard-traceability'
export const URL_DASHBOARD_TRACEABILITY_DETAIL = '/dashboard-traceability/:id'

// QR PRINTING
export const URL_QR_PRINTING = '/qr-printing'
